import React from "react";
import classNames from "classnames/bind";
import {useStateManager} from "../../utils/useStateManager";

import Step1 from "../../images/step1.png";
import Step2 from "../../images/step2.png";
import Ios from "../../images/Ios.png"

import styles from "./TelegramError.module.css";

const cx = classNames.bind(styles);

type Props = {};

export const TelegramError: React.FC<Props> = (props) => {
    const {telegramTypeError} = useStateManager()
    const getScreenContent = () => {
        switch (telegramTypeError) {
            case 'android' :
                return [
                    {
                        title: 'Шаг 1',
                        description: 'Нажмите три точки в правом верхнем углу экрана:',
                        url: Step1,
                        alt: 'шаг 1'
                    },
                    {
                        title: 'Шаг 2',
                        description: 'Нажмите первый пункт открывшегося меню:',
                        url: Step2,
                        alt: 'шаг 2'
                    }
                ]
            case 'ios' :
                return [
                    {
                        title: '',
                        description: 'Нажмите иконку в правом нижнем углу экрана:',
                        url: Ios,
                        alt: 'шаг 1'
                    },
                ]
            default :
                return  []
        }
    }

    const steps = getScreenContent()

    return (
        <div className={cx("container")}>
            <h1 className={cx('title')}>Пожалуйста, откройте наш сервис в браузере.</h1>
            <ul className={cx('items')}>
                {steps.map(step => (
                    <li className={cx('item')}>
                        { step?.title && <h2 className={cx('step')}>{step.title}</h2>}
                        <p className={cx('description')}>{step.description}</p>
                        <img className={cx('image')} src={step.url} alt={step.alt}/>
                    </li>
                ))}
            </ul>
        </div>
    );
};
